import http from "src/services/http";
import queryString from "query-string";
import * as types from "src/store/types/usuarios";
import store from "..";

export const carregarUsuarios = (paginacao) => {
  const { usuarios_filtro } = store.getState().usuarios;
  const qry = queryString.stringify(
    { ...usuarios_filtro, ...paginacao },
    { arrayFormat: "index" }
  );
  return (dispatch) => {
    dispatch({ type: types.USUARIOS_LOADING, payload: true });
    http.get(`/api/v2/empresa/usuarios?${qry}`).then(
      (resp) => {
        const { total, current_page: page, per_page, data } = resp.data;
        dispatch([
          { type: types.USUARIOS_SET_USUARIOS, payload: data },
          { type: types.USUARIOS_SET_PAGE, payload: parseInt(page) },
          { type: types.USUARIOS_SET_TOTAL, payload: parseInt(total) },
          { type: types.USUARIOS_SET_PERPAGE, payload: parseInt(per_page) },
          { type: types.USUARIOS_LOADING, payload: false },
        ]);
      },
      (error) => {
        dispatch([{ type: types.USUARIOS_LOADING, payload: false }]);
      }
    );
  };
};

export const atualizarPermissoes = (id, permissoes) => {
  store.dispatch({ type: types.USUARIOS_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http
      .patch(`/api/v2/empresa/usuarios/permissoes/${id}`, { permissoes })
      .then(
        () => {
          store.dispatch({ type: types.USUARIOS_LOADING, payload: false });
          store.dispatch(carregarUsuarios());
          resolve();
        },
        (e) => reject(e)
      );
  });
};

export const cadastrarUsuario = (usuario) => {
  store.dispatch({ type: types.USUARIOS_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http.post("/api/v2/empresa/usuarios", usuario).then(
      () => {
        store.dispatch({ type: types.USUARIOS_LOADING, payload: false });
        store.dispatch(carregarUsuarios());
        resolve();
      },
      (e) => reject(e)
    );
  });
};

export const atualizarSituacao = (id, situacao) => {
  return new Promise((resolve, reject) => {
    http.patch(`/api/v2/empresa/usuarios/situacao/${id}`, { situacao }).then(
      (resp) => {
        store.dispatch([carregarUsuarios()]);
        resolve();
      },
      (error) => {
        store.dispatch([{ type: types.USUARIOS_LOADING, payload: false }]);
        reject(error);
      }
    );
  });
};
